(function () {
var $59e4ae3b15dde189$export$6d10441bd0a505b0 = {
    rideshare: '.rideshare',
    scroll: '.rideshare__trigger--scroll-up',
    toggle: 'button.rideshare__trigger',
    item: '.rideshare__item',
    itemTrigger: '.rideshare__item .rideshare__trigger',
    footer: 'footer.footer'
};
var $59e4ae3b15dde189$export$ba41d43e4a419565 = {
    scrolling: 'rideshare--scrolling',
    scrollTop: 'rideshare--scroll-top',
    scrollBottom: 'rideshare--scroll-bottom',
    itemOpened: 'rideshare__item--opened',
    itemClosing: 'rideshare__item--closing'
};


var $b8ec2b292e42a133$var$SESSION_STORAGE_KEY = 'rideshareContentClosed';
var $b8ec2b292e42a133$export$6f80a5815d01d072 = function() {
    return sessionStorage.getItem($b8ec2b292e42a133$var$SESSION_STORAGE_KEY) === '1';
};
var $b8ec2b292e42a133$export$6399a740c47e2288 = function() {
    sessionStorage.setItem($b8ec2b292e42a133$var$SESSION_STORAGE_KEY, '1');
};


var $c7f794f6950de5bf$var$TRIGGER_ANIMATION_DURATION = 500;
var $c7f794f6950de5bf$var$initRideshare = function() {
    var rideshare = document.querySelector((0, $59e4ae3b15dde189$export$6d10441bd0a505b0).rideshare);
    if (!rideshare) return;
    var lastScrollTop = 0;
    var hasAutoClosedContent = false;
    var userInteracted = false;
    var scrollUpIndicator = rideshare.querySelector((0, $59e4ae3b15dde189$export$6d10441bd0a505b0).scroll);
    // Calculate bottom offset.
    var footer = document.querySelector((0, $59e4ae3b15dde189$export$6d10441bd0a505b0).footer);
    var _footer_getBoundingClientRect_height;
    var bottomOffset = (_footer_getBoundingClientRect_height = footer === null || footer === void 0 ? void 0 : footer.getBoundingClientRect().height) !== null && _footer_getBoundingClientRect_height !== void 0 ? _footer_getBoundingClientRect_height : 0;
    // Close all open rideshare item contents.
    var closeAllItemContents = function() {
        var openItems = rideshare.querySelectorAll(".".concat((0, $59e4ae3b15dde189$export$ba41d43e4a419565).itemOpened));
        openItems.forEach(function(item) {
            var _item_querySelector;
            item.classList.add((0, $59e4ae3b15dde189$export$ba41d43e4a419565).itemClosing);
            item.classList.remove((0, $59e4ae3b15dde189$export$ba41d43e4a419565).itemOpened);
            (_item_querySelector = item.querySelector((0, $59e4ae3b15dde189$export$6d10441bd0a505b0).toggle)) === null || _item_querySelector === void 0 ? void 0 : _item_querySelector.setAttribute('aria-expanded', 'false');
            setTimeout(function() {
                return item.classList.remove((0, $59e4ae3b15dde189$export$ba41d43e4a419565).itemClosing);
            }, $c7f794f6950de5bf$var$TRIGGER_ANIMATION_DURATION);
        });
        return openItems.length > 0;
    };
    // Close rideshare when escape key is pressed.
    document.addEventListener('keydown', function(event) {
        if (event.key === 'Escape' && closeAllItemContents()) (0, $b8ec2b292e42a133$export$6399a740c47e2288)();
    });
    // Close rideshare when clicking outside of it.
    document.addEventListener('click', function(event) {
        var eventPath = typeof event.composedPath === 'function' ? event.composedPath() : [];
        var isClickInside = eventPath.includes(rideshare) || event.target instanceof Node && rideshare.contains(event.target);
        if (!isClickInside) closeAllItemContents();
    });
    // Add classes to the rideshare element based on the scroll position.
    var onScroll = function() {
        var classList = rideshare.classList;
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        var isScrollingDown = scrollTop > lastScrollTop;
        if (scrollTop === 0) {
            // Page is at the top.
            classList.remove((0, $59e4ae3b15dde189$export$ba41d43e4a419565).scrolling);
            classList.add((0, $59e4ae3b15dde189$export$ba41d43e4a419565).scrollTop);
        } else {
            // Page is scrolled.
            classList.remove((0, $59e4ae3b15dde189$export$ba41d43e4a419565).scrollTop);
            classList.add((0, $59e4ae3b15dde189$export$ba41d43e4a419565).scrolling);
            // Close all item contents if the user scrolls down and hasn't interacted with any item.
            if (isScrollingDown && scrollTop > 200 && !hasAutoClosedContent && !userInteracted) {
                hasAutoClosedContent = true;
                closeAllItemContents();
            }
            // Reached the bottom of the page.
            if (window.innerHeight + window.scrollY >= document.body.offsetHeight - bottomOffset) classList.add((0, $59e4ae3b15dde189$export$ba41d43e4a419565).scrollBottom);
            else classList.remove((0, $59e4ae3b15dde189$export$ba41d43e4a419565).scrollBottom);
        }
        lastScrollTop = scrollTop;
    };
    if (scrollUpIndicator) scrollUpIndicator.addEventListener('click', function() {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    });
    onScroll();
    window.addEventListener('scroll', onScroll, {
        passive: true
    });
    var openItemContent = function(item) {
        var _item_querySelector;
        closeAllItemContents();
        item.classList.remove((0, $59e4ae3b15dde189$export$ba41d43e4a419565).itemClosing);
        item.classList.add((0, $59e4ae3b15dde189$export$ba41d43e4a419565).itemOpened);
        (_item_querySelector = item.querySelector((0, $59e4ae3b15dde189$export$6d10441bd0a505b0).toggle)) === null || _item_querySelector === void 0 ? void 0 : _item_querySelector.setAttribute('aria-expanded', 'true');
    };
    // Toggle individual rideshare item content.
    var toggleItemContent = function(item) {
        var isOpened = item.classList.contains((0, $59e4ae3b15dde189$export$ba41d43e4a419565).itemOpened);
        if (isOpened) {
            closeAllItemContents();
            (0, $b8ec2b292e42a133$export$6399a740c47e2288)();
        } else openItemContent(item);
    };
    // Setup event listeners for all item triggers (excluding scroll-up trigger).
    var itemTriggers = rideshare.querySelectorAll((0, $59e4ae3b15dde189$export$6d10441bd0a505b0).itemTrigger);
    itemTriggers.forEach(function(trigger) {
        if (trigger !== scrollUpIndicator) {
            trigger.setAttribute('aria-expanded', 'false');
            trigger.addEventListener('click', function() {
                userInteracted = true;
                var item = trigger.closest((0, $59e4ae3b15dde189$export$6d10441bd0a505b0).item);
                if (item) toggleItemContent(item);
            });
        }
    });
    // Open rideshare if the user is at the top of the page and has not closed the rideshare.
    setTimeout(function() {
        if (userInteracted || window.scrollY !== 0 || (0, $b8ec2b292e42a133$export$6f80a5815d01d072)()) return;
        var openItemAttr = rideshare.getAttribute('data-open-item');
        var itemToOpen = openItemAttr ? rideshare.querySelector(".rideshare__item--".concat(openItemAttr)) : null;
        if (itemToOpen) openItemContent(itemToOpen);
    }, 500);
};
$c7f794f6950de5bf$var$initRideshare();

})();
//# sourceMappingURL=rideshare.min.js.map
